import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  User,
} from 'firebase/auth';
import { auth } from './firebase';
import { UserInitResponse, userApi } from './api/endpoints/user';
import { ExtendedUser } from '../contexts/AuthContext';

export interface AuthError {
  code: string;
  message: string;
}

export const authService = {
  register: async (email: string, password: string): Promise<ExtendedUser> => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    const user_id = user.uid;

    const res = await userApi.initUser({ user_id });

    if (res.status < 200 || res.status >= 300) {
      throw new Error("Failed to initialize user profile");
    }

    const profile = res.data as UserInitResponse;

    const extendedUser: ExtendedUser = {
      ...user,
      token_allowance: profile.token_allowance,
      tokens_left_current_period: profile.tokens_left_current_period,
      account_type: profile.account_type,
    };
    return extendedUser;
  },

  login: async (email: string, password: string): Promise<ExtendedUser> => {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    const user_id = user.uid;

    const res = await userApi.initUser({ user_id });
    if (res.status < 200 || res.status >= 300) throw new Error("Failed to fetch user quota");

    const profile = res.data as UserInitResponse;

    const extendedUser: ExtendedUser = {
      ...user,
      token_allowance: profile.token_allowance,
      tokens_left_current_period: profile.tokens_left_current_period,
      account_type: profile.account_type,
    };
    return extendedUser;
  },

  logout: (): Promise<void> => {

    return signOut(auth);
  },

  getCurrentUser: (): User | null => {
    return auth.currentUser;
  },

  getToken: async (): Promise<string | null> => {
    const user = auth.currentUser;
    if (!user) return null;
    return user.getIdToken();
  }
};